import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useQuery } from '@tanstack/react-query'
import { useAppContext, useSetCurrentClient } from '../../../../../redux/slices/appContext'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import SydAutocomplete from '../../../../commonDesign/SydAutocomplete'
import useDebouncedValue from '../../../../../hooks/useDebounceValue'
import { fetchClients } from '../../../../../service'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    gridGap: '1rem',
    alignItems: 'center',
    justifyContent: 'end'
  },
  selectContainer: {
    width: '200px'
  }
}))

export const ClientPreviewContextSelect = () => {
  const classes = useStyles()
  const { clientId: contextClientId, loadingClient } = useAppContext()
  const setCurrentClient = useSetCurrentClient()

  const [clientId, setClientId] = useState(contextClientId)
  const [searchText, setSearchText] = useState('')
  const debouncedSearchText = useDebouncedValue(searchText, 500)

  useEffect(() => {
    setClientId(contextClientId)
  }, [contextClientId])

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.reports, 'infographics', 'clients', clientId, debouncedSearchText],
    queryFn: async () => {
      const data = await fetchClients({
        take: 10,
        ...(debouncedSearchText?.length ? { search: debouncedSearchText } : {}),
        ...(clientId && !debouncedSearchText?.length ? { clientIds: [clientId] } : {})
      })

      return data?.data || []
    },
    select: (data) => data?.map(client => ({
      value: client.clientId,
      label: client.shortName
    })) ?? []
  })

  return (
    <div className={classes.container}>
      Viewing preview in context of
      <div className={classes.selectContainer}>
        <SydAutocomplete
          size='sm'
          value={debouncedSearchText?.length ? debouncedSearchText : data?.find(client => client.value === clientId)?.label || null}
          onChange={(e, val) => {
            if (!val) return
            setSearchText('')
            setClientId(val?.value || null)
            setCurrentClient(val?.value || null)
          }}
          options={data || []}
          isLoading={isLoading || loadingClient}
          onInputChange={(e, val) => {
            setClientId(null)
            setSearchText(val)
          }}
        />
      </div>
    </div>
  )
}
